import * as React from 'react';
import { cn } from '@/lib/utils';

const QuestionMenu = React.forwardRef(({ className, ...props }, ref) => (
  <nav
    ref={ref}
    className={cn('question-menu', 'flex flex-col gap-8 rounded-[10px] border border-white bg-[#FDFCFA] p-5', 'shadow-[0px_4px_10px_rgba(68,43,140,0.05)]', className)}
    {...props}
  />
));
QuestionMenu.displayName = 'QuestionMenu';

const QuestionMenuTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn('question-menu-title', 'mb-1 text-[14px] font-bold text-neutral-dark', className)}
    {...props}
  />
));
QuestionMenuTitle.displayName = 'QuestionMenuTitle';

const QuestionMenuList = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('question-menu-list', 'grid grid-cols-[repeat(auto-fill,minmax(36px,1fr))] gap-2', className)}
    {...props}
  />
));
QuestionMenuList.displayName = 'QuestionMenuList';

const QuestionMenuLink = React.forwardRef(({ className, active, disabled, ...props }, ref) => (
  <button
    ref={ref}
    className={cn(
      'question-menu-link',
      'flex h-9 items-center justify-center rounded-[4px] border-0 bg-white p-2 text-[12px] font-bold text-neutral-dark underline transition-all duration-150',
      'shadow-[0px_4px_10px_rgba(68,43,140,0.05)] hover:shadow-[0px_4px_10px_rgba(68,43,140,0.1)]',
      active && 'bg-secondary text-white opacity-100',
      disabled && !active && 'opacity-40',
      className
    )}
    {...props}
  />
));
QuestionMenuLink.displayName = 'QuestionMenuLink';

export { QuestionMenu, QuestionMenuTitle, QuestionMenuList, QuestionMenuLink };
